/**
 * TestimonialsSection Component
 * Landing page customer testimonials
 */

import { Star } from "lucide-react";
import { TESTIMONIALS } from "./constants";

export const TestimonialsSection = () => {
  return (
    <section id="testimonials" className="py-20 px-6 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent"></div>
      <div className="container mx-auto max-w-6xl relative z-10">
        <h2 className="text-4xl font-bold text-center text-primary mb-4">
          Loved by E-commerce Brands
        </h2>
        <p className="text-center text-foreground/70 mb-12 max-w-xl mx-auto">
          See how leading brands are transforming their visual content with
          MerchMidas.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {TESTIMONIALS.map((testimonial, index) => (
            <div key={index} className="p-6 rounded-2xl glass">
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className="text-primary fill-primary"
                    size={18}
                  />
                ))}
              </div>
              <p className="text-foreground/80 mb-4 italic">
                "{testimonial.content}"
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center text-primary font-semibold">
                  {testimonial.name[0]}
                </div>
                <div>
                  <p className="font-medium text-primary">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-foreground/60">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
